import styled from 'styled-components';
import { media } from '@common/theme';

export const StepContainer = styled.div`
  width: 66%;
  max-width: 500px;
  position: relative;
  display: flex;
  justify-content: center;
  font-size: 12px;
`;

export const StepStage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 5px;
  text-transform: capitalize;
`;

export const CurrentStepIndicator = styled.div`
  background-color: ${({ theme }) => theme.primaryColour};
  width: 10px;
  height: 10px;
  border-radius: 50%;
`;

export const ConnectingLine = styled.div`
  background-color: ${({ theme }) => theme.greyColors['grey-10']};
  width: 50px;
  margin-top: 10px;
  height: 1px;
  ${media.desktop`
    width: 100px;
    margin-top: 16px;
    `}
`;

export const StepIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border: 1px solid ${({ theme }) => theme.primaryColour};
  border-radius: 50%;
  ${media.desktop`
    width: 32px;
    height: 32px;
  `}

  svg {
    color: ${({ theme }) => theme.primaryColour};
  }
`;
